import { useParams } from 'react-router';
import React, { useEffect, useMemo, useState } from 'react';
import { useGetFisheryQuery } from '../fishery_profile/fisherySlice';
import { createSelector } from '@reduxjs/toolkit';
import { Alert } from 'antd';
import './assets/css/widget.css';
import '../admin/components/bookings/assets/css/admin_booking.css';
import '../user_bookings/assets/css/user_bookings.css';
import { useLocation } from 'react-router-dom';
import { sendWidgetMessage } from '../../utils/widgetUtils';
import { UserBookings } from '../user_bookings';
import WidgetLoading from './components/WidgetLoading';
import StartBookingButton from './assets/media/StartBookingButton';
import widgetClose from './assets/media/widget-close.svg';

function ThirdPartyBookingWidget() {
  const searchParams = new URLSearchParams(useLocation().search);
  const fisheryId = useParams()['fishery_id'];
  const isOpen =
    (searchParams.get('open') ?? false)?.toLowerCase?.() === 'true';
  const [localIsOpen, setLocalIsOpen] = useState(isOpen);

  useEffect(() => {
    setLocalIsOpen(isOpen);
  }, [isOpen]);

  const publicIdSelector = useMemo(() => {
    return createSelector(
      (result) => result.data,
      (fisheryData) => fisheryData?.public_id
    );
  }, []);
  const {
    data: fisheryPublicId,
    isLoading: loading,
    isError: errorLoadingFisheryId,
  } = useGetFisheryQuery(fisheryId, {
    selectFromResult: (result) => ({
      ...result,
      data: publicIdSelector(result),
    }),
  });

  if (!localIsOpen) {
    return (
      <StartBookingButton
        className='cp'
        onClick={() => {
          sendWidgetMessage({ type: 'widgetExpand' });
          setLocalIsOpen(true); // Optimistic update
        }}
      />
    );
  }

  if (loading) {
    return <WidgetLoading />;
  }

  if (errorLoadingFisheryId || !fisheryPublicId) {
    return (
      <Alert
        message={'Something went wrong!'}
        description={
          'Please try again later or contact swimbooker for support.'
        }
        type='error'
      />
    );
  }

  return (
    <div className='swimbooker-booking-widget'>
      <img
        src={widgetClose}
        alt={'Close'}
        role='button'
        className='swimbooker-booking-widget__close_btn cp'
        onClick={() => {
          sendWidgetMessage({ type: 'widgetCollapse' });
          setLocalIsOpen(false); // Optimistic update
        }}
      />
      <UserBookings fisheryId={fisheryPublicId ? String(fisheryPublicId) : null} inWidget={true} />
    </div>
  );
}

export default ThirdPartyBookingWidget;
